<div class="screen-overlay flex-col text-center">
  <nz-empty />
  <!-- <nz-empty
    nzNotFoundImage="assets/empty-box.png"
    [nzNotFoundContent]="null"
   />
  <h3 class="!min-w-auto">No results found</h3> -->
</div>
